module.exports = __webpack_public_path__ + "static/media/card-remove-icon.8b2d0447.svg";